<!--期待生存率セクションのコンテンツレイアウト、デザインを記述するファイル-->
<template>
  <div>
    <div class="section3--content">
      <slot name="heading" />
    </div>

    <div class="section3--content section3--content__text" :style="{color: textcolor}">
      <div>
        <slot name="text1" />
      </div>
      <div class="section3--content__text--inner">
        <slot name="value-with-unit1" />
      </div>
    </div>

    <div class="section3--content section3--content__text" :style="{color: textcolor2}">
      <div>
        <slot name="text2" />
      </div>
      <div class="section3--content__text--inner">
        <slot name="value-with-unit2" />
      </div>
    </div>
  </div>
</template>

<script>
import VueTypes from "vue-types";

export default {
  props: {
    textcolor: VueTypes.string.isRequired,
    textcolor2: VueTypes.string.isRequired
  }
};
</script>

<style scoped>
.section3--content__text {
  margin-top: 40px;
}
.section3--content__text--inner {
  margin-top: 20px;
}
</style>
